/* unplugin-vue-components disabled */import { render } from "./standardmap.vue?vue&type=template&id=218a9cc6&scoped=true"
import script from "./standardmap.vue?vue&type=script&lang=js"
export * from "./standardmap.vue?vue&type=script&lang=js"

import "./standardmap.vue?vue&type=style&index=0&id=218a9cc6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218a9cc6"]])

export default __exports__